module.exports = __webpack_public_path__ + "static/media/Applications.d3f10357.svg";